<template>
    <div class="check-list">
        <div class="d-flex check-all" @click="onSelectItem('all')" v-if="useCheckAllOption">
            <SOCheckBox :is-checked="isCheckAll" />
            <label class="m-l-8 m-d-0">Pilih Semua</label>
        </div>
        <div class="list-item-container">
            <div class="" v-for="(options, idx) in getOption" :key="`options-group${idx.replace(/ /g, '_')}`">
                <div class="d-flex-between-center list-item" v-if="groupBy">
                    <div class="d-flex">
                        <div @click="onSelectItem(idx)">
                            <SOCheckBox :is-checked="isCheckedGroup(options) || isCheckAll" />
                        </div>
                        <label class="m-l-8 m-d-0" @click="toggleExpand(idx.replace(/ /g, '_'))">{{ idx }}</label>
                    </div>
                    <div class="m-r-8" @click="toggleExpand(idx.replace(/ /g, '_'))">
                        <SOIconBase viewBox="0 0 14 8" width="14" height="8" v-if="isExpanded(idx.replace(/ /g, '_'))">
                            <template v-slot:icon>
                                <ExpandArrow1408 />
                            </template>
                        </SOIconBase>
                        <SOIconBase viewBox="0 0 14 8" width="14" height="8" v-else>
                            <template v-slot:icon>
                                <UnExpandArrow1408 />
                            </template>
                        </SOIconBase>
                    </div>
                </div>
                <div v-else @click="onSelectItem(options)" class="d-flex list-item">
                    <SOCheckBox :is-checked="isCheckedItem(options) || isCheckAll" />
                    <label class="m-l-8 m-d-0">{{ options[labelKey] }}</label>
                </div>
                <div v-if="isExpanded(idx.replace(/ /g, '_'))">
                    <div class="nd-item" v-for="(opt, key) in options" :key="`opt-item${key}`">
                        <div class="d-flex list-item" @click="onSelectItem(opt)">
                            <SOCheckBox :is-checked="isCheckedItem(opt) || isCheckAll" />
                            <label class="m-l-8 m-d-0">{{ opt[labelKey] }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SOCheckBox from "@/so-components/global/ui/SOCheckBox.vue";

import SOIconBase from "@/so-components/global/icons/SOIconBase.vue";
import ExpandArrow1408 from "@/so-components/global/icons/iconPacks/ExpandArrow1408.vue";
import UnExpandArrow1408 from "@/so-components/global/icons/iconPacks/UnExpandArrow1408.vue";

export default {
    name: "SODeepChecklist",
    props: {
        useCheckAllOption: {
            type: Boolean,
            default: false,
        },
        isCheckAll: {
            type: Boolean,
            default: false,
        },

        selectedOptions: {
            type: Array,
            default: () => {
                return [];
            },
        },
        options: {
            type: Array,
            default: () => {
                return [];
            },
        },
        groupBy: {
            type: String,
            default: "",
        },
        labelKey: {
            type: String,
            default: "nama",
        },
        labelVal: {
            type: String,
            default: "id",
        },
    },
    data() {
        return {
            expandedGroups: [],
        };
    },
    components: {
        SOCheckBox,
        SOIconBase,
        ExpandArrow1408,
        UnExpandArrow1408,
    },
    computed: {
        isCheckedItem() {
            return (item) => {
                let existing = this.selectedOptions.find((opt) => opt[this.labelVal] === item[this.labelVal]);

                return existing ? true : false;
            };
        },
        isCheckedGroup() {
            return (items) => {
                if (!this.groupBy) {
                    return false;
                }
                let selected = true;
                items.forEach((item) => {
                    let existing = this.isCheckedItem(item);

                    if (!existing) {
                        selected = false;
                        return;
                    }
                });
                return selected;
            };
        },
        isExpanded() {
            return (group) => {
                let exist = this.expandedGroups.find((g) => g === group);

                let selectOnGroup = this.selectedOptions.find((s) => s[this.groupBy] === group);

                return exist || selectOnGroup? true : false;
            };
        },
        getOption() {
            let { groupBy, options } = this;
            if (!groupBy) {
                return options;
            } else {
                return options.reduce(function(a, e) {
                    let groupKey = e[groupBy];

                    (a[groupKey] ? a[groupKey] : (a[groupKey] = null || [])).push(e);

                    return a;
                }, {});
            }
        },
    },
    methods: {
        toggleExpand(val) {
            let exist = this.expandedGroups.find((g) => g === val);
            if (!exist) {
                this.expandedGroups.push(val);
            } else {
                let newGroup = this.expandedGroups.filter((g) => g !== val);
                this.expandedGroups = newGroup;
            }
        },
        onSelectItem(val) {
            this.$emit("onSelect", val);
        },
    },
};
</script>
<style scoped>
.check-list {
    border: 1px solid #c8d0dd;
    box-sizing: border-box;
    border-radius: 5px;
    padding: 0px 16px;
}

.check-all {
    background: #f8f8f8;
    box-sizing: border-box;
    border-bottom: 1px solid #c8d0dd;
    padding: 6px 16px;
    margin: 0px -16px;
    border-radius: 5px 5px 0px 0px;
}

.list-item {
    padding: 6px 0px;
}

.list-item-container {
    max-height: 40vh;
    overflow: hidden;
    overflow-y: scroll;
}

.nd-item {
    padding-left: 22px;
}
</style>
